<div class="wrapper">
  <app-content></app-content>
  <app-sidebar></app-sidebar>
</div>
<!--<app-footer></app-footer>-->
